import { ShowWhenRule } from '../models/questionnaire.model'

export function evaluateShowWhen(
  rule: ShowWhenRule,
  answeredByKey: Record<string, any>
): boolean {
  const answer = answeredByKey[rule.questionKey]
  if (rule.operator === 'equals') return answer === rule.value
  if (rule.operator === 'in') {
    const values = (rule.value ?? '').split('|')
    return values.includes(answer)
  }
  if (rule.operator === 'has_selection') {
    const exclude = rule.value ? rule.value.split('|') : []
    if (!answer) return false
    if (Array.isArray(answer))
      return answer.filter((v: string) => !exclude.includes(v)).length > 0
    if (typeof answer === 'string') {
      try {
        const parsed = JSON.parse(answer)
        const selected = Array.isArray(parsed.selected)
          ? parsed.selected
          : Array.isArray(parsed)
          ? parsed
          : []
        return selected.filter((v: string) => !exclude.includes(v)).length > 0
      } catch {
        return false
      }
    }
    return false
  }
  if (rule.operator === 'includes_any') {
    const targets = (rule.value ?? '').split('|')
    if (!answer) return false
    if (Array.isArray(answer))
      return answer.some((v: string) => targets.includes(v))
    if (typeof answer === 'string') {
      try {
        const parsed = JSON.parse(answer)
        const selected = Array.isArray(parsed.selected)
          ? parsed.selected
          : Array.isArray(parsed)
          ? parsed
          : []
        return selected.some((v: string) => targets.includes(v))
      } catch {
        return false
      }
    }
    return false
  }
  if (rule.operator === 'matrix_includes_any') {
    const targets = (rule.value ?? '').split('|')
    if (!answer) return false
    try {
      const parsed = typeof answer === 'string' ? JSON.parse(answer) : answer
      const selections = parsed.selections ?? parsed
      if (!selections || typeof selections !== 'object') return false
      return Object.values(selections).some(
        (selection) =>
          typeof selection === 'string' && targets.includes(selection)
      )
    } catch {
      return false
    }
  }
  return false
}
